





































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import store from '@/store';
import RgInfo from './components/rg-info.vue';
import eventBus from '@/utils/event-bus';
import * as api from '@/api';
/**
 * RG详情tab页
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component({
    components: {
        RgInfo
    }
})
export default class RgDetail extends Vue {
    @State(state => state.cti.permission)
    permission: CommonTypes.mapObject;

    activeName: string = '';
    isNewVersion: boolean = false;
    knowledgeGray: boolean = false;
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    created() {
        this.getRgGray();
        this.checkOncallVersion();
        this.getActiveTab();
        this.getRgPermission();
        // 切换路由时更新tab
        eventBus.$on('changeTabActive', this.handleChangeActive);
    }
    async checkOncallVersion() {
        const res = await api.ctiApi.getOncall(this.rgId);
        if (res && res.code === 200) {
            this.isNewVersion = !!res.data;
            store.commit('GET_RG_ONCALL_VERSION', this.isNewVersion);
        }
    }
    async getRgGray() {
        const res = await api.rgApi.getRgGray(this.rgId);
        if (res && res.code === 200) {
            this.knowledgeGray = !!res.data.knowledgeGray;
        }
    }
    getActiveTab() {
        const routeName = this.$route.name;
        this.activeName = routeName.split('_').slice(0, 2).join('_');
    }
    handleChangeTab() {
        this.$router
            .push({
                name: this.activeName,
                query: {
                    rgId: `${this.rgId}`
                }
            })
            .catch(e => e);
    }
    handleChangeActive(activeName: string) {
        this.activeName = activeName;
    }
    async getRgPermission() {
        const res = await api.rgApi.getRgPermission(this.rgId);
        const { code, data } = res;
        if (code === 200) {
            store.commit('GET_USER_PERMISSION', data.permissionAll);
        }
    }
}
